import React from 'react';

export default function Privacy() {
    return (
        <div className="privacy-policy">
            <h1>Privacy Policy</h1>
            
            <section>
                <h2>1. Information We Collect</h2>
                <p>We collect information you provide directly, such as when you contact us or use our services. This may include your name, email address, and any other information you choose to share.</p>
            </section>

            <section>
                <h2>2. How We Use Your Information</h2>
                <p>We use the information we collect to provide, maintain, and improve our services, respond to your inquiries, and comply with legal obligations.</p>
            </section>

            <section>
                <h2>3. Data Security</h2>
                <p>We implement reasonable security measures to protect your personal information from unauthorized access and disclosure.</p>
            </section>

            <section>
                <h2>4. Third-Party Services</h2>
                <p>Our website may contain links to third-party services. We are not responsible for their privacy practices. Please review their policies independently.</p>
            </section>

            <section>
                <h2>5. Changes to This Policy</h2>
                <p>We may update this privacy policy from time to time. We will notify you of any significant changes by posting the new policy on this page.</p>
            </section>

            <section>
                <h2>6. Contact Us</h2>
                <p>If you have questions about this privacy policy, please contact us at seanfh@proton.me</p>
            </section>
        </div>
    );
}